var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _g, _path35, _path36;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFrame1000004486(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 778,
    height: 260,
    viewBox: "0 0 778 260",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M128 0H-2V130H128V0Z",
    fill: "#4650EF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M-2 130H78.47C78.47 102.646 100.646 80.4702 128 80.4702V0.0327148H125.162C54.68 1.53855 -2 59.1502 -2 130Z",
    fill: "#FFEEF0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M258 0H128V130H258V0Z",
    fill: "#4650EF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M258 0C222.24 0.140833 193.293 29.185 193.293 65C193.293 100.815 222.24 129.859 258 130V0Z",
    fill: "#FFEEF0"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M128 130C163.761 129.859 192.707 100.815 192.707 65C192.707 29.185 163.761 0.140833 128 0V130Z",
    fill: "#FFEEF0"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M388 0H258V130H388V0Z",
    fill: "#FFEEF0"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M369.92 112.558H274.24V16.9541H369.92V112.558ZM289.287 97.5866H354.861V31.9258H289.298V97.5758L289.287 97.5866Z",
    fill: "#4650EF"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M337.787 48.2625H308.212V77.6966H337.787V48.2625Z",
    fill: "#4650EF"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M518 0H388V130H518V0Z",
    fill: "#FFEEF0"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M517.957 65C517.957 100.88 488.858 129.978 452.957 130V94.3042C470.864 94.3042 485.37 79.7983 485.37 61.9125C485.37 44.0267 470.853 29.5208 452.957 29.5208V0C488.858 0.0216667 517.957 29.12 517.957 65Z",
    fill: "#4650EF"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M453 65C453 100.88 423.902 129.978 388 130V94.3042C405.908 94.3042 420.414 79.7983 420.414 61.9125C420.414 44.0267 405.908 29.51 388 29.51V0C423.902 0.0216667 453 29.12 453 65Z",
    fill: "#4650EF"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M648 0H518V130H648V0Z",
    fill: "#FFEEF0"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M518 65L583 130V0L518 65Z",
    fill: "#4650EF"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M583 65L648 0V130L583 65Z",
    fill: "#4650EF"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M778 0H648V130H778V0Z",
    fill: "#4650EF"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M648 130L778 0V130H648Z",
    fill: "#4650EF"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M747.656 64.9785L712.357 29.6797L677.059 64.9785L712.357 100.277L747.656 64.9785Z",
    fill: "#FFEEF0"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M128 130H-2V260H128V130Z",
    fill: "#4650EF"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M63 260L128 194.979H-2L63 260Z",
    fill: "#FFEEF0"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M63 195.022L-2 130H128L63 195.022Z",
    fill: "#FFEEF0"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M258 130H128V260H258V130Z",
    fill: "#FFEEF0"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M193.065 260C157.163 260 128.043 230.977 128.043 195.162C163.955 195.162 193.065 224.185 193.065 260Z",
    fill: "#3340BC"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M192.957 260C228.87 260 257.979 230.977 257.979 195.162C222.066 195.162 192.957 224.185 192.957 260Z",
    fill: "#4650EF"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M193.065 194.935C157.163 194.935 128.043 165.912 128.043 130.097C163.955 130.097 193.065 159.131 193.065 194.935Z",
    fill: "#3340BC"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M192.957 194.935C228.87 194.935 257.979 165.912 257.979 130.097C222.066 130.097 192.957 159.131 192.957 194.935Z",
    fill: "#4650EF"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M388 130H258V260H388V130Z",
    fill: "#FFEEF0"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M387.999 130C352.239 130.141 323.292 159.185 323.292 195C323.292 230.815 352.239 259.859 387.999 260V130Z",
    fill: "#4650EF"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M258 260C293.761 259.859 322.707 230.815 322.707 195C322.707 159.185 293.761 130.141 258 130V260Z",
    fill: "#4650EF"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M518 130H388V260H518V130Z",
    fill: "#4650EF"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M452.762 260H388V195L452.762 260Z",
    fill: "#FFEEF0"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M452.762 195H388V130L452.762 195Z",
    fill: "#FFEEF0"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M518 260H453.238V195L518 260Z",
    fill: "#FFEEF0"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M518 195H453.238V130L518 195Z",
    fill: "#FFEEF0"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1420_19738",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 518,
    y: 130,
    width: 130,
    height: 131
  }, _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M648 130H518V260H648V130Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1420_19738)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M647.946 129.914H517.946V259.914H647.946V129.914Z",
    fill: "#FFEEF0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M582.957 74.7396L462.924 194.773L582.957 314.806L702.99 194.773L582.957 74.7396ZM478.892 194.773L582.957 90.708L687.011 194.762L582.957 298.816L478.892 194.773Z",
    fill: "#4650EF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M582.958 106.676L494.861 194.773L582.947 282.859L671.033 194.773L582.958 106.676ZM510.84 194.773L582.958 122.655L655.075 194.773L582.958 266.89L510.84 194.773Z",
    fill: "#4650EF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M582.957 138.624L526.808 194.773L582.957 250.922L639.106 194.773L582.957 138.624ZM542.776 194.773L582.957 154.592L623.138 194.773L582.957 234.954L542.776 194.773Z",
    fill: "#4650EF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M582.957 170.561L558.755 194.762L582.957 218.964L607.159 194.762L582.957 170.561ZM574.724 194.762L582.957 186.529L591.19 194.762L582.957 202.996L574.724 194.762Z",
    fill: "#4650EF"
  }))), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M778 130H648V260H778V130Z",
    fill: "#4650EF"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M648 260V179.53C675.354 179.53 697.53 157.354 697.53 130H778C778 201.804 719.792 260 648 260Z",
    fill: "#FFEEF0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrame1000004486);
export default __webpack_public_path__ + "static/media/Frame 1000004486.a01b03fe6e01054984f69243bdeb3ac7.svg";
export { ForwardRef as ReactComponent };